import { ANALYTICS_API_URL } from "../utils/constant";
const { REACT_APP_BASE_URL, REACT_APP_GATEWAY_BASE_URL_PROD, REACT_APP_ACTIVATE_SEGMENT_BASE_URL, } = process.env;
// const { REACT_APP_BASE_URL, REACT_APP_GATEWAY_BASE_URL_PROD } = process.env;
export const Apis = {
    "get-expiry": {
        key: "get-expiry",
        endpoint: `${REACT_APP_BASE_URL}demo-project/V2/GetExpiryForSymbolOptions`,
    },
    "get-options": {
        key: "get-options",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetOptionsForSymbol`,
    },
    "get-fno-scripts": {
        key: "get-fno-scripts",
        endpoint: (symbol) => {
            return (REACT_APP_BASE_URL +
                "demo-project/FNO-Rollover/" +
                symbol +
                "/priceperchange/desc?responseType=JSON");
        },
    },
    "get-fno-scripts-and-index": {
        key: "get-fno-scripts-and-index",
        endpoint: REACT_APP_BASE_URL + "demo-project/fno-rollover/desc",
    },
    "get-index-pcr": {
        key: "get-index-pcr",
        endpoint: (symbol, endpoint) => {
            return (REACT_APP_BASE_URL +
                "demo-project" +
                `/FutOptOverview/${endpoint}/` +
                symbol +
                "?responseType=JSON");
        },
    },
    "get-index-pcr-ratio": {
        key: "get-index-pcr-ratio",
        endpoint: (unknownType, valueType, date, symbol, unknownType1) => {
            return (REACT_APP_BASE_URL +
                "demo-project" +
                "/Get-Put-Call-Ratio/" +
                unknownType +
                "/" +
                valueType +
                "/" +
                date +
                "/" +
                symbol +
                "/" +
                unknownType1 +
                "?responseType=JSON");
        },
    },
    "get-net-position-net-wise": {
        key: "get-net-position-net-wise",
        endpoint: `${REACT_APP_BASE_URL}demo-project/NetPositionNetWise`,
    },
    "get-webhook-token": {
        key: "get-webhook-token",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetSecretTokenByMobile`,
    },
    "get-webhook-details": {
        key: "get-webhook-details",
        endpoint: `${REACT_APP_BASE_URL}demo-project/FetchWebHookDetails`,
    },
    "get-net-position": {
        key: "get-net-position",
        endpoint: `${REACT_APP_BASE_URL}demo-project/NetPosition`,
    },
    "get-margin": {
        key: "get-margin",
        endpoint: `${REACT_APP_BASE_URL}demo-project/MarginV10`,
    },
    "get-option-greeks": {
        key: "get-option-greeks",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetOptionsGreek`,
    },
    "get-basket": {
        key: "get-basket",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetBaskets`,
    },
    "search-fo-scrip": {
        key: "search-fo-scrip",
        endpoint: `${REACT_APP_BASE_URL}demo-project/SearchFOScrip`,
    },
    "scrip-details-fo-order": {
        key: "scrip-details-fo-order",
        endpoint: `${REACT_APP_BASE_URL}demo-project/v5/ScripDetailsFoFOOrder`,
    },
    "scrip-details-fo-order-v4": {
        key: "scrip-details-fo-order-v4",
        endpoint: `${REACT_APP_BASE_URL}demo-project/v4/ScripDetailsFoFOOrder`,
    },
    "scrip-details-fo-order-v6": {
        key: "scrip-details-fo-order-v6",
        endpoint: `${REACT_APP_BASE_URL}demo-project/ScripDetailsFoFOOrder`,
    },
    "margin-calculation": {
        key: "margin-calculation",
        endpoint: `${REACT_APP_BASE_URL}demo-project/PreOrdMarginCalculationV1`,
    },
    "create-order-request": {
        key: "create-order-request",
        endpoint: `${REACT_APP_BASE_URL}demo-project/OrderRequest-V3`,
    },
    "get-screener": {
        key: "get-screener",
        endpoint: (gainerOrLooserFlag, unknown2, unknown3) => {
            return (REACT_APP_BASE_URL +
                "demo-project" +
                "/fogainerlooser/" +
                gainerOrLooserFlag +
                "/" +
                unknown2 +
                "/" +
                unknown3 +
                "?responsetype=json");
        },
    },
    "option-dashboard": {
        key: "option-dashboard",
        endpoint: (expiryType) => {
            return (REACT_APP_BASE_URL + "demo-project" + "/optionDashBoard/" + expiryType);
        },
    },
    "future-dashboard": {
        key: "future-dashboard",
        endpoint: (expiryType) => {
            return (REACT_APP_BASE_URL + "demo-project" + "/futuresDashboard/" + expiryType);
        },
    },
    "future-trend": {
        key: "future-trend",
        endpoint: (expiryType, categoryType) => {
            return (REACT_APP_BASE_URL +
                "demo-project" +
                "/futuresTrend/" +
                expiryType +
                "/" +
                categoryType);
        },
    },
    "option-trend": {
        key: "option-trend",
        endpoint: (expiry, activity) => {
            return REACT_APP_BASE_URL + "demo-project/" + activity + "/" + expiry;
        },
    },
    "get-watchlist-list": {
        key: "get-watchlist-list",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetMWatchListRVMW1`,
    },
    "get-vtt-orderbook": {
        key: "get-vtt-orderbook",
        endpoint: `${REACT_APP_BASE_URL}demo-project/V2/GetVTTOrder`,
    },
    "modify-vtt-orderbook": {
        key: "modify-vtt-orderbook",
        endpoint: `${REACT_APP_BASE_URL}demo-project/ModifyVTTOrder`,
    },
    "get-news": {
        key: "get-news",
        // endpoint: `${REACT_APP_BASE_URL}demo-project/news/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InBhcnRoLnNoYWhANXBhaXNhLmNvbSIsImlhdCI6MTYzMTM3NjMyNH0.fwTvCs8A803HPv1ZeWYjBvXDsV-51yMpRAnRIfT6QzI`,
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetNews`,
    },
    "get-corporate": {
        key: "get-corporate",
        endpoint: REACT_APP_BASE_URL +
            "demo-project" +
            "/Corporate-Announcement?responseType=JSON",
    },
    "get-watchlist": {
        key: "get-watchlist",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetNewMarketWatch`,
    },
    "get-mf-v4": {
        key: "get-mf-v4",
        // endpoint: `${REACT_APP_BASE_URL}demo-project/V4/MarketFeed`,
        endpoint: `${REACT_APP_BASE_URL}demo-project/V3/MarketFeed`,
    },
    "get-guest-login-check": {
        key: "get-guest-login-check",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GuestLoginCheck`,
    },
    "get-options-data": {
        key: "get-options-data",
        endpoint: (symbol) => {
            return `${REACT_APP_BASE_URL}demo-project/FutOptOverview/opt/${symbol}?responseType=JSON`;
        },
    },
    "get-options-fut-data": {
        key: "get-options-fut-data",
        endpoint: (symbol) => {
            return `${REACT_APP_BASE_URL}demo-project/FutOptOverview/fut/${symbol}?responseType=JSON`;
        },
    },
    "get-fiidii": {
        key: "get-fiidii",
        // endpoint:
        //   "https://pearl.trendlyne.com/clientapi/pearlapi/macro-data/fii-dii/",
        endpoint: `${REACT_APP_BASE_URL}demo-project/fii-dii`,
    },
    "get-screener-data": {
        key: "get-screener-data",
        endpoint: "",
    },
    "get-order-in-basket": {
        key: "get-order-in-basket",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetOrderInBasket`,
    },
    "get-mf-v6": {
        key: "get-mf-v6",
        endpoint: `${REACT_APP_BASE_URL}demo-project/V6/MarketFeed`,
    },
    "get-indices": {
        key: "get-indices",
        endpoint: "https://papi.indiainfoline.com/IIFL/equity/market.svc/sector-indices/nse?responseType=json",
    },
    "set-indices": {
        key: "set-indices",
        endpoint: `${REACT_APP_BASE_URL}demo-project/SetIndices`,
    },
    "get-market-depth-20": {
        key: "get-market-depth-20",
        endpoint: `${REACT_APP_BASE_URL}demo-project/20depth`,
    },
    "get-market-depth-5": {
        key: "get-market-depth-5",
        endpoint: `${REACT_APP_BASE_URL}demo-project/MarketDepth`,
    },
    "get-candlestick-technical-analysis": {
        key: "get-candlestick-technical-analysis",
        endpoint: (timeRange) => {
            return `${REACT_APP_BASE_URL}demo-project/CandlestickAnalysis/technicalsignal/${timeRange}`;
        },
    },
    "access-token-validation": {
        key: "access-token-validation",
        endpoint: `${REACT_APP_BASE_URL}5peaccountuat/access-token-validation`,
    },
    "get-slice-limit": {
        key: "get-slice-limit",
        endpoint: `${REACT_APP_BASE_URL}demo-project/CheckIsSliceEnable`,
    },
    "create-vtt-order": {
        key: "create-vtt-order",
        endpoint: `${REACT_APP_BASE_URL}demo-project/AddVTTOrder`,
    },
    login: {
        key: "login",
        endpoint: REACT_APP_BASE_URL + "demo-project" + "/LoginRequestMobileNewbyEmail-V5",
    },
    "check-login": {
        key: "login",
        endpoint: REACT_APP_BASE_URL + "tradeapi" + "/CheckLoginResponseV3",
    },
    "post-convert-position": {
        key: "post-convert-position",
        endpoint: `${REACT_APP_BASE_URL}demo-project/PosConMob`,
    },
    "get-order-book": {
        key: "get-order-book",
        endpoint: `${REACT_APP_BASE_URL}demo-project/V4/OrderBook`,
    },
    "get-trade-book": {
        key: "get-trade-book",
        endpoint: `${REACT_APP_BASE_URL}demo-project/TradeBookV2`,
    },
    "get-single-order-detail": {
        key: "get-single-order-detail",
        endpoint: `${REACT_APP_BASE_URL}demo-project/OrderHistory`,
    },
    "get-order-update": {
        key: "get-order-update",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetOrderUpdates`,
    },
    "get-chart-token": {
        key: "get-chart-token",
        endpoint: `${REACT_APP_BASE_URL}demo-project/V2/ChartToken`,
    },
    // "elastic-search": {
    //   key: "elastic-search",
    //   endpoint: `${REACT_APP_BASE_URL}demo-project/elastic-search`,
    // },
    "create-basket": {
        key: "create-basket",
        endpoint: `${REACT_APP_BASE_URL}demo-project/CreateBasket`,
    },
    "get-active-equity": {
        key: "get-active-equity",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetActiveEquityByVolume`,
    },
    "add-to-watchlist": {
        key: "add-to-watchlist",
        endpoint: `${REACT_APP_BASE_URL}demo-project/SaveMW`,
    },
    "delete-basket": {
        key: "delete-basket",
        endpoint: `${REACT_APP_BASE_URL}demo-project/V2/DeleteBasket`,
    },
    "execute-basket": {
        key: "execute-basket",
        endpoint: `${REACT_APP_BASE_URL}demo-project/ExecuteBasket`,
    },
    "rename-basket": {
        key: "rename-basket",
        endpoint: `${REACT_APP_BASE_URL}demo-project/EditBasketName`,
    },
    "add-to-basket": {
        key: "add-to-basket",
        endpoint: `${REACT_APP_BASE_URL}demo-project/AddOrderToBasket-V1`,
    },
    "delete-vtt-order": {
        key: "delete-vtt-order",
        endpoint: `${REACT_APP_BASE_URL}demo-project/V2/DeleteVTTOrder`,
    },
    "get-logout": {
        key: "get-logout",
        endpoint: `${REACT_APP_BASE_URL}demo-project/Logout`,
    },
    "get-market-status": {
        key: "get-market-status",
        endpoint: `${REACT_APP_BASE_URL}demo-project/MarketStatus`,
    },
    "create-smo-order": {
        key: "create-smo-order",
        endpoint: `${REACT_APP_BASE_URL}demo-project/SMOOrderRequest`,
    },
    "modify-smo-order": {
        key: "modify-smo-order",
        endpoint: `${REACT_APP_BASE_URL}demo-project/ModifySMOOrder-V1`,
    },
    "pre-order-margin-calculation": {
        key: "pre-order-margin-calculation",
        endpoint: `${REACT_APP_BASE_URL}demo-project/PreOrdMarginCalculationBulkV2`,
    },
    "basket-clone": {
        key: "basket-clone",
        endpoint: `${REACT_APP_BASE_URL}demo-project/CloneBasket`,
    },
    "delete-order-in-basket": {
        key: "delete-order-in-basket",
        endpoint: `${REACT_APP_BASE_URL}demo-project/DeleteOrderInBasket`,
    },
    // "modify-order-in-basket": {
    //   key: "modify-order-in-basket",
    //   endpoint: `${REACT_APP_BASE_URL}demo-project/ModifyOrderInBasket-V1`,
    // },
    "modify-order-in-basket": {
        key: "modify-order-in-basket",
        endpoint: `${REACT_APP_BASE_URL}demo-project/V2/ModifyOrderInBasket`,
    },
    "get-market-depth-token": {
        key: "get-market-depth-token",
        endpoint: `${REACT_APP_BASE_URL}demo-project/depth-token`,
    },
    "get-rollover": {
        key: "get-rollover",
        endpoint: `${REACT_APP_BASE_URL}demo-project/priceperchange/desc?responseType=JSON`,
    },
    "get-dpholding": {
        key: "get-dpholding",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetDPHoldingV1`,
    },
    "get-script-wise-dpholding": {
        key: "get-script-wise-dpholding",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetScripWiseDPHolding`,
    },
    "generate-bo-pin": {
        key: "generate-bo-pin",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GenerateBOPin`,
    },
    "get-client-info": {
        key: "get-client-info",
        endpoint: `${REACT_APP_BASE_URL}demo-project/V1/ClientInfo`,
    },
    "get-sell-authorization-status": {
        key: "get-sell-authorization-status",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetSellAuthorizationStatus`,
    },
    "get-company-detail": {
        key: "get-company-detail",
        endpoint: `${REACT_APP_BASE_URL}demo-project/V8/CompanyDetailPage`,
    },
    "get-company-detail-demo-project": {
        key: "get-company-detail",
        endpoint: `${REACT_APP_BASE_URL}demo-project/CompanyDetailPage`,
    },
    "set-notification-details": {
        key: "set-notification-details",
        endpoint: `${REACT_APP_BASE_URL}demo-project/SetNotificationDetailsV1`,
    },
    "login-check": {
        key: "login-check",
        endpoint: `${REACT_APP_BASE_URL}demo-project/LoginCheck`,
    },
    "get-expiry-symbol-future": {
        key: "get-expiry-symbol-future",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetExpiryForSymbolFuture`,
    },
    "get-intraday-screener-option-expiries": {
        key: "get-intraday-screener-option-expiries",
        endpoint: (pageType, scripType) => {
            // return `${REACT_APP_BASE_URL}demo-project/api/${pageType}/expiries/${scripType}`;
            return `${REACT_APP_BASE_URL}demo-project/optionDashBoard_marketdata/expiry`;
        },
    },
    "get-intraday-screener-future-expiries": {
        key: "get-intraday-screener-expiries",
        // endpoint: `${REACT_APP_BASE_URL}demo-project/FNODashboard/expiries`,
        endpoint: `${REACT_APP_BASE_URL}demo-project/futures/expiry`,
    },
    "get-quick-option-trade": {
        key: "get-quick-option-trade",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetQuickOptionTrade`,
    },
    "get-advisory-details": {
        key: "get-advisory-details",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetAdvisoryDetails`,
    },
    "get-advisory-basket-details": {
        key: "get-advisory-basket-details",
        endpoint: `${REACT_APP_BASE_URL}CRM/Advisory/V1/GetAdvisoryBasketDetails`,
    },
    "get-onelogin-token": {
        key: "get-onelogin-token",
        endpoint: `${REACT_APP_BASE_URL}demo-project/onelogintoken`,
    },
    "get-oi-gainers": {
        key: "get-oi-gainers",
        endpoint: (date) => {
            return `${REACT_APP_BASE_URL}demo-project/fnoTrend/${date}/activeBYValue`;
        },
    },
    "get-indices-v3": {
        key: "get-indices-v3",
        endpoint: `${REACT_APP_BASE_URL}demo-project/IndicesV3`,
    },
    "get-indices-detail-page": {
        key: "get-indices-detail-page",
        endpoint: `${REACT_APP_BASE_URL}demo-project/IndicesDetailPage`,
    },
    "elastic-search-v2": {
        key: "elastic-search",
        endpoint: `${REACT_APP_BASE_URL}demo-project/elastic-search-v2`,
    },
    "order-request-bulk": {
        key: "order-request-bulk",
        endpoint: `${REACT_APP_BASE_URL}demo-project/OrderRequestBulk-v1`,
    },
    "get-future-intraday-buildup": {
        key: "get-future-intraday-buildup",
        endpoint: (symbol, expiry) => {
            return `${REACT_APP_BASE_URL}demo-project/futIntradayBuildupV1/${symbol}/${expiry}`;
        },
    },
    "get-index-contributors": {
        key: "get-index-contributors",
        endpoint: (symbol) => {
            return `${REACT_APP_BASE_URL}demo-project/indexcontributorsV1/${symbol}`;
        },
    },
    "predefined-strategy": {
        key: "predefined-strategy",
        endpoint: `${REACT_APP_BASE_URL}demo-project/PreDefinedStrategy`,
    },
    "strategy-builder-payoff-new": {
        key: "strategy-builder-payoff",
        endpoint: (symbol, daysToExpiry, expiry, minStrike, maxStrike) => {
            //  symbol,daysToExpiry,expiry,minStrike,maxStrike
            // "demo-project/FNO-Rollover/" +
            //   symbol +
            //   "/priceperchange/desc?responseType=JSON"
            // return (
            //   REACT_APP_BASE_URL +
            //   "demo-project/strategyBuilderPayoff/" +
            //   symbol +
            //   "?daysToExpiry=" +
            //   daysToExpiry +
            //   "&expiry=" +
            //   expiry +
            //   "&minStrike=" +
            //   minStrike +
            //   "&maxStrike=" +
            //   maxStrike
            // );
            return (REACT_APP_GATEWAY_BASE_URL_PROD +
                "demo-project/strategyBuilderPayoffV1/" +
                symbol +
                "?daysToExpiry=" +
                daysToExpiry +
                "&expiry=" +
                expiry +
                "&minStrike=" +
                minStrike +
                "&maxStrike=" +
                maxStrike);
            //'https://gateway.5paisa.com/demo-project/strategyBuilderPayoff/NIFTY 50?daysToExpiry=5&expiry=28-Sep-2023&minStrike=19200&maxStrike=21000' \
            //symbol,daysToExpiry,expiry,minStrike,maxStrike
        },
    },
    "multi-strike-oi": {
        key: "multi-strike-oi",
        endpoint: (symbol) => {
            return `${REACT_APP_BASE_URL}demo-project/multistrikeOi/${symbol}`;
        },
    },
    "margin-plus-status": {
        key: "margin-plus-status",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetMarginPlusStatus`,
    },
    "update-margin-plus-status": {
        key: "update-margin-plus-status",
        endpoint: `${REACT_APP_BASE_URL}demo-project/UpdateMarginPlusStatus`,
    },
    "get-client-profile": {
        key: "get-client-profile",
        endpoint: REACT_APP_BASE_URL + "demo-project/v2/FetchClientProfile",
    },
    "get-brokerage-calculation": {
        key: "get-brokerage-calculation",
        endpoint: REACT_APP_BASE_URL + "demo-project/BrokerageCalculation",
    },
    //NEW API FOR BROKERAGE
    "get-brokerage-calculation-v2": {
        key: "get-brokerage-calculation-v2",
        endpoint: REACT_APP_BASE_URL + "BoAPI/Common/BrokerageCalculation",
    },
    "cash-filter": {
        key: "cash-filter",
        endpoint: REACT_APP_BASE_URL + "demo-project/V1/CashFilter",
    },
    // "get-marketfeed-token": {
    //   key: "get-marketfeed-token",
    //   endpoint: REACT_APP_BASE_URL + "demo-project/marketfeed-token",
    // },
    "get-default-strategies-selection": {
        key: "get-default-strategies-selection",
        endpoint: REACT_APP_BASE_URL + "demo-project/DefaultStrategiesSelection",
    },
    "strike-type-list": {
        key: "strike-type-list",
        endpoint: REACT_APP_BASE_URL + "demo-project/striketypelist",
    },
    "AT-add": {
        key: "AT-add",
        endpoint: REACT_APP_BASE_URL + "demo-project/ATAdd",
    },
    AT_getdata: {
        key: "AT_getdata",
        endpoint: REACT_APP_BASE_URL + "demo-project/ATgetdata",
    },
    "payoff-chart": {
        key: "payoff-chart",
        endpoint: REACT_APP_BASE_URL + "demo-project/PayOffChart",
    },
    "get-smart-sso-login": {
        key: "get-smart-session-transfer",
        endpoint: REACT_APP_BASE_URL + "demo-project/SessionTransferWrapperVendor",
    },
    "get-smart-net-position": {
        key: "get-smart-net-position",
        endpoint: REACT_APP_BASE_URL + "demo-project/ATNetPosition",
    },
    "get-smart-net-position-depth": {
        key: "get-smart-net-position-depth",
        endpoint: REACT_APP_BASE_URL + "demo-project/NetPositionDepth",
    },
    "get-history-smart-strategies": {
        key: "get-history-smart-strategies",
        endpoint: REACT_APP_BASE_URL + "demo-project/getTradeLog",
    },
    "set-square-off-smart-strategies": {
        key: "set-square-off-smart-strategies",
        endpoint: REACT_APP_BASE_URL + "demo-project/ATDashboard",
    },
    "session-transfer-wrapper": {
        key: "session-transfer-wrapper",
        endpoint: REACT_APP_BASE_URL + "demo-project/SessionTransferWrapperVendor",
    },
    "allow-TMO-OptionScrip": {
        key: "allow-TMO-OptionScrip",
        endpoint: REACT_APP_BASE_URL + "demo-project/AllowTMOOptionScrip",
    },
    "sso-session": {
        key: "sso-session",
        endpoint: REACT_APP_BASE_URL + "demo-project/SessionSSO",
    },
    TMOScripList: {
        key: "TMOScripList",
        endpoint: REACT_APP_BASE_URL + "demo-project/TMOScripList",
    },
    // "pre-order-margin-calculation-bulk": {
    //   key: "pre-order-margin-calculation-bulk",
    //   endpoint: `${REACT_APP_GATEWAY_BASE_URL_PROD}demo-project/PreOrdMarginCalculationBulk`,
    // },
    // V3 Bulk Margin
    "pre-order-margin-calculation-bulk": {
        key: "pre-order-margin-calculation-bulk",
        endpoint: `${REACT_APP_GATEWAY_BASE_URL_PROD}demo-project/V3/PreOrdMarginCalculationBulk`,
    },
    "marginuser-CDSL-authorization": {
        key: "marginuser-CDSL-authorization",
        endpoint: `${REACT_APP_BASE_URL}demo-project/PostDataToCDSLMF`,
    },
    "pledge-margin-funding": {
        key: "pledge-margin-funding",
        endpoint: `${REACT_APP_BASE_URL}demo-project/Get/GetPledgeMarginFunding`,
    },
    "get-realtime-holding": {
        key: "get-realtime-holding",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetRealTimeHolding`,
    },
    "get-realtime-holdingV2": {
        key: "get-realtime-holding",
        endpoint: `${REACT_APP_BASE_URL}swarajcore/V2/GetRealTimeHolding`,
    },
    "set-derivatives-preference": {
        key: "set-derivatives-preference",
        endpoint: (clientCode) => {
            return `${REACT_APP_BASE_URL}demo-project/post/derivative/preference/${clientCode}`;
        },
    },
    "get-derivatives-preference": {
        key: "get-derivatives-preference",
        endpoint: (clientCode) => {
            return `${REACT_APP_BASE_URL}demo-project/derivative/preference/${clientCode}`;
        },
    },
    // "set-chart-preference": {
    //   key: "set-chart-preference",
    //   endpoint: `${REACT_APP_BASE_URL}demo-project/post/chart/preference/${localStorage.getItem(
    //     "clientCode"
    //   )}`,
    // },
    // "get-chart-preference": {
    //   key: "get-chart-preference",
    //   endpoint: (clientCode: string): string => {
    //     return `${REACT_APP_BASE_URL}demo-project/chart/preference/${clientCode}`;
    //   },
    // },
    "get-chart-token-socket": {
        key: "get-chart-token",
        endpoint: `${REACT_APP_GATEWAY_BASE_URL_PROD}demo-project/ChartToken`,
    },
    "get-holding": {
        key: "get-holding",
        endpoint: `${REACT_APP_BASE_URL}demo-project/HoldingV7`,
    },
    "get-pledge-request": {
        key: "get-pledge-request",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetPledgeRequestV1`,
    },
    "get-unpledge-request": {
        key: "get-pledge-request",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetUnPledgeRequestV1`,
    },
    "save-unpledge-request": {
        key: "save-unpledge-request",
        endpoint: `${REACT_APP_BASE_URL}demo-project/SaveUnpledgeRequestV1`,
    },
    "holding-CDSL-authorization": {
        key: "holding-CDSL-authorization",
        endpoint: `${REACT_APP_BASE_URL}demo-project/PostDataToCDSLMPV1`,
    },
    "get-indices-master": {
        key: "get-indices-master",
        endpoint: `${REACT_APP_BASE_URL}demo-project/IndiceMasterNewV3`,
    },
    "get-indices-master-v3": {
        key: "get-indices-master-v3",
        endpoint: `${REACT_APP_GATEWAY_BASE_URL_PROD}demo-project/IndicesV3`,
    },
    "set-master-indices": {
        key: "set-master-indices",
        endpoint: `${REACT_APP_BASE_URL}demo-project/SetIndices`,
    },
    "get-option-chain-list": {
        key: "get-option-chain-list",
        endpoint: (scirptName, type) => {
            return `https://papi.indiainfoline.com/IIFL/FNO/FutOpt.svc/FutOptOverview/${type}/${scirptName}?responseType=JSON`;
        },
    },
    "get-option-for-symbol": {
        key: "get-option-for-symbol",
        endpoint: (scirptName, expiry, exch, exchType) => {
            return `${REACT_APP_GATEWAY_BASE_URL_PROD}demo-project/GetOptionsForSymbolV3/${scirptName}/${exch}/${exchType}/${expiry}`;
        },
    },
    "get-fo-stock-details": {
        key: "get-fo-stock-details",
        endpoint: (symbol) => {
            return (REACT_APP_BASE_URL +
                "demo-project/FutOptIndvidualStockDetail-version2/" +
                symbol +
                "/-/-/-/0/-?responsetype=json");
        },
    },
    "get-mwpl-banlist": {
        key: "get-mwpl-banlist",
        endpoint: `${REACT_APP_GATEWAY_BASE_URL_PROD}demo-project/V1/MWPLBanList`,
    },
    "set-Price-Alert": {
        key: "set-Price-Alert",
        endpoint: `${REACT_APP_BASE_URL}demo-project/V3/PriceAlert`,
    },
    "get-Price-Alert": {
        key: "get-Price-Alert",
        endpoint: `${REACT_APP_BASE_URL}demo-project/V2/GetPriceAlert`,
    },
    "modify-Price-Alert": {
        key: "modify-Price-Alert",
        endpoint: `${REACT_APP_BASE_URL}demo-project/V2/ModifyPriceAlert`,
    },
    "delete-Price-Alert": {
        key: "delete-Price-Alert",
        endpoint: `${REACT_APP_BASE_URL}demo-project/DeletePriceAlert`,
    },
    "get-BOD-Holding": {
        key: "Get-BOD-Holding",
        endpoint: `${REACT_APP_BASE_URL}demo-project/GetBODHolding`,
    },
    "get-notification": {
        key: "get-notification",
        endpoint: `${REACT_APP_GATEWAY_BASE_URL_PROD}demo-project/NotificationCenter`,
    },
    "get-mf-margin": {
        key: "get-mf-margin",
        endpoint: `${REACT_APP_GATEWAY_BASE_URL_PROD}demo-project/viewmfmargin`,
    },
    "get-margin-v11": {
        key: "get-margin-v11",
        endpoint: `${REACT_APP_GATEWAY_BASE_URL_PROD}demo-project/V11/Margin`,
    },
    "get-strangle-data": {
        key: "get-strangle-data",
        endpoint: (index, strikePrice1, strikeprice2) => {
            if (strikePrice1 === "" || strikeprice2 === "") {
                return `${REACT_APP_GATEWAY_BASE_URL_PROD}demo-project/strangle/${index}`;
            }
            else {
                return `${REACT_APP_GATEWAY_BASE_URL_PROD}demo-project/strangle/${index}?callStrinke=${strikePrice1}&putStrinke=${strikeprice2}`;
            }
            // return `${REACT_APP_GATEWAY_BASE_URL_PROD}demo-project/strangle/${index}?callStrinke=${strikePrice1}&putStrinke=${strikeprice2}`;
            // https://gateway.5paisa.com/demo-project/strangle/NIFTY?callStrinke=21650&putStrinke=21500
        },
    },
    "get-straddle-data": {
        key: "get-straddle-data",
        endpoint: (index) => {
            return `${REACT_APP_GATEWAY_BASE_URL_PROD}demo-project/straddle/${index}`;
        },
    },
    "get-stratzy-active-signal": {
        key: "get-stratzy-active-signal",
        endpoint: `${REACT_APP_GATEWAY_BASE_URL_PROD}demo-project/activeSignals`,
    },
    "get-client-info-v1": {
        key: "get-client-info-v1",
        endpoint: `${REACT_APP_GATEWAY_BASE_URL_PROD}demo-project/ClientInfoV1`,
    },
    "push-segment-v1": {
        key: "push-segment-v1",
        endpoint: `${REACT_APP_ACTIVATE_SEGMENT_BASE_URL}PushSegment_V1`,
    },
    "get-client-modification-status": {
        key: "get-client-modification-status",
        endpoint: `${REACT_APP_ACTIVATE_SEGMENT_BASE_URL}GetClientModificationStatus`,
    },
    "analytics-clickhouse": {
        key: "analytics-clickhouse",
        endpoint: `${ANALYTICS_API_URL}/v1/event/add`,
    },
    "get-max-pain-data": {
        key: "get-max-pain-data",
        endpoint: (index) => `${REACT_APP_GATEWAY_BASE_URL_PROD}demo-project/maxpainlive/${index}`,
    },
    "get-jwtToken": {
        key: "get-jwtToken",
        endpoint: `${REACT_APP_ACTIVATE_SEGMENT_BASE_URL}JWTToken`,
    },
    "extract-cookie-from-header": {
        key: "extract-cookie-from-header",
        endpoint: `${REACT_APP_BASE_URL}Tradestation/extractCookieFromHeader`,
    },
    "delete-cookie": {
        key: "delete-cookie",
        endpoint: `https://pwaprodapi.5paisa.com/DeleteCookie`,
    },
};
